import React, { useState, useEffect } from 'react'

// Libraries
import { Col, Container, Row } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Thumbs } from "swiper/modules";
import Lightbox from 'react-18-image-lightbox';

import { Parallax } from "react-scroll-parallax";
import { m } from 'framer-motion'
// Components
import Buttons from '../../Components/Button/Buttons'
import { fadeIn } from '../../Functions/GlobalAnimations';

// Data
import axios from 'axios';
import config from '../../config';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {  ChevronLeft } from 'lucide-react'



const SingleStory = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0)
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  import("../../Functions/Utilities").then(module => {
    module.InputField(1);
  })

  const handleClick = (i) => {
    setIsOpen(true)
    setPhotoIndex(i)
  }

  const [story, setStory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [quantity, setQuantity] = useState(1); 
  const [actionLoading, setActionLoading] = useState(false);
  const location = useLocation();
  const id = location.pathname.split('/').pop();
  useEffect(() => {
    const fetchStories = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${config.REACT_APP_API_URL}/product/${id}`,{
            headers: { 
            'x-api-key': config.SITE_API_KEY
           }});
        const storyData = response.data;
        setStory(storyData);
        
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchStories();
  }, [id]);

  // Gestion de la quantité
  const handleQuantityChange = (type) => {
    if (type === 'increment') {
      setQuantity(prev => Math.min(prev + 1, story.stock || 999));
    } else if (type === 'decrement' && quantity > 1) {
      setQuantity(prev => prev - 1);
    }
  };

  const handleQuantityInput = (e) => {
    const value = parseInt(e.target.value);
    if (!isNaN(value) && value >= 1) {
      setQuantity(Math.min(value, story.stock || 999));
    }
  };

  // Fonction pour ajouter une story au panier avec quantité
  const handleAddToBasket = async (productId) => {
    const token = localStorage.getItem("accessToken");

    try {
      setActionLoading(true);
      const response = await axios.post(
        `${config.REACT_APP_API_URL}/add-to-basket`,
        { 
          productId,
          quantity // Envoyer la quantité avec la requête
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'x-api-key': config.SITE_API_KEY
          },
        }
      );
      toast.success(response.data.message);
      setQuantity(1); // Réinitialiser la quantité après ajout
    } catch (error) {
      toast.error(error.response?.data?.message || "Erreur lors de l'ajout au panier");
    } finally {
      setActionLoading(false);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!story) {
    return <div>Commande not found</div>;
  }
  // Create swiper data from story images if available
  const swiperData = story.picture  === '/picture/product/' ? [
    { img: "/img/product.jpg" }
  ] : [
    { img: config.REACT_APP_API_URL + story.picture }];

  return (
    <div className="single-product" style={props.style}>
            {/* Parallax Section Start */}
                        <m.div className="h-[380px] overflow-hidden sm:h-[200px] relative" {...fadeIn}>
                            <Parallax 
                                className="lg-no-parallax bg-cover absolute top-0 left-0 w-full h-full" 
                                translateY={[-40, 40]} 
                                style={{ backgroundImage: `url(/assets/img/webp/portfolio-bg.webp)` }}
                            />
                            <Container className="h-full relative">
                                <Row className="items-stretch justify-center h-[450px] md:h-[375px] sm:h-[275px]">
                                    <Col xl={6} lg={7} md={8} xs={12} className="text-center flex justify-center flex-col">
                                        <h2 className="text-darkgray mb-[0px] font-kurale font-medium -tracking-[1px] xs:mb-[0px]">{story.name}</h2>
                                    </Col>
                                </Row>
                            </Container>
                        </m.div>
                        {/* Parallax Section End */}

      {/* Header retour */}
      <div className="border-b">
        <Container className="py-4">
          <Link
            to={`/product-by-category/${story.category?._id || ''}`}
            className="flex items-center gap-2 text-[#558927] hover:text-[#87c03d]"
          >
            <ChevronLeft className="w-4 h-4" />
            Retour aux produits
          </Link>
        </Container>
      </div>

      {/* Section Start */}
      <section className="py-[30px] min-lg:py-[40px] min-md:py-[95px] min-sm:py-[80px] min-xs:py-[50px] overflow-hidden">
        <Container>
          <Row>
            <Col className="col-12 flex flex-column flex-lg-row align-items-md-center" >
              <div className="w-[40%] md:w-full mb-20">
                <Row>
                  <Col lg={{ span: 9, order: 2 }} className="relative product-image md:mb-[10px] px-lg-0">
                    <Swiper
                      style={{
                        "--swiper-navigation-color": "#fff",
                        "--swiper-pagination-color": "#fff",
                        boxShadow: "20px 20px 20px rgba(0, 0, 0, 0.4)"
                      }}
                      spaceBetween={10}
                      navigation={true}
                      thumbs={{ swiper: thumbsSwiper }}
                      modules={[Navigation, Thumbs]}
                      className="mySwiper2 w-full product-images-box"
                    >
                      {swiperData.map((item, i) => (
                        <SwiperSlide key={i} onClick={() => handleClick(i)}>
                          <img
                            src={item.img}
                            alt={story.name}
                            width="512"
                            height="652.8"
                            className="w-full"
                            loading="lazy"
                          />
                        </SwiperSlide>
                      ))}
                    </Swiper>

                    {isOpen && swiperData.length > 0 && (
                      <Lightbox
                        imageCaption={`${photoIndex + 1} of ${swiperData.length}`}
                        mainSrc={swiperData[photoIndex].img}
                        onCloseRequest={() => setIsOpen(false)}
                        nextSrc={swiperData[(photoIndex + 1) % swiperData.length]?.img}
                        prevSrc={swiperData[(photoIndex + swiperData.length - 1) % swiperData.length]?.img}
                        onMovePrevRequest={() =>
                          setPhotoIndex((photoIndex + swiperData.length - 1) % swiperData.length)
                        }
                        onMoveNextRequest={() =>
                          setPhotoIndex((photoIndex + 1) % swiperData.length)
                        }
                        reactModalProps={{ contentLabel: "Produit image viewer" }}
                      />
                    )}
                  </Col>
                </Row>
              </div>

                            <div className="w-[60%] md:w-full product-summary">
                              <div className="flex items-start justify-between mb-6">
                                  <p className="text-sm text-gray-500 font-semibold mb-2 uppercase tracking-wide">
                                    {story.category?.name || ''}
                                  </p>
                                  <p className="text-sm text-gray-500 font-semibold mb-2 uppercase tracking-wide">
                                    <span className="text-sm text-darkgray">Code: </span>{story.code}
                                  </p>
                              </div>
              
                                  <h1 className="text-4xl font-bold text-gray-900 mb-3">{story.name}</h1>
                              {/* Prix + stock */}
                              <div className="bg-gray-50 p-6 rounded-xl border mb-8">
                                <div className="mb-4">
                                <h2 className="text-xl font-bold text-gray-900 mb-4">Description</h2>
                                  <p className="text-gray-600 leading-relaxed">
                                  {story.longDescription || story.description || 'Aucune description disponible.'}
                                </p>
                                </div>
                              </div>
              
                               {/* Quantité + boutons */}
                <div className="space-y-4">
                  <div className="flex items-center gap-5">
                    <span className="font-semibold text-gray-900">Quantité :</span>
                    <div className="flex items-center border rounded-lg overflow-hidden">
                      <button
                        onClick={() => handleQuantityChange('decrement')}
                        className="px-4 py-2 hover:bg-gray-100 disabled:opacity-50"
                        disabled={quantity <= 1 || actionLoading}
                      >
                        -
                      </button>
                      <input
                        type="text"
                        value={quantity}
                        onChange={handleQuantityInput}
                        className="px-6 py-2 font-semibold min-w-[3rem] text-center w-20 border-0 focus:ring-0"
                        disabled={actionLoading}
                        min="1"
                        max={story.stock || 999}
                      />
                      <button
                        onClick={() => handleQuantityChange('increment')}
                        className="px-4 py-2 hover:bg-gray-100 disabled:opacity-50"
                        disabled={quantity >= (story.stock || 999) || actionLoading}
                      >
                        +
                      </button>
                    </div>
                    {story.stock && (
                      <span className="text-sm text-gray-500">
                        Stock: {story.stock}
                      </span>
                    )}
                  </div>

                  <Buttons
                    ariaLabel="add-to-cart" 
                    onClick={(e) => {
                      e.preventDefault();
                      handleAddToBasket(story._id);
                    }}
                    className="btn-fill font-medium font-serif rounded-none uppercase disabled:opacity-50"
                    themeColor="#558927"
                    color="#fff"
                    size="lg"
                    title={actionLoading ? "Ajout en cours..." : `Ajouter au panier (${quantity})`}
                    disabled={actionLoading}
                  />
                              </div>
                            </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* Section End */}
      
            <ToastContainer position="bottom-left" />

    </div>
  )
}

export default SingleStory